import React, { Component, Fragment } from 'react';
import { parseSearchFilters, removeQueryParameter } from 'utils/utils';
import CardUltimasBuscas from 'components/CarouselContainer/CardUltimasBuscas';
import './LastSearches.scss';

export default class LastSearches extends Component {
  static LKID = 2031;

  renderMakeModel(filters) {
    if (filters && filters.marca1 && filters.modelo1) {
      const make = decodeURIComponent(filters.marca1).toUpperCase();
      const model = decodeURIComponent(filters.modelo1).toUpperCase();
      return [make, model, false];
    }
    return ['', '', false];
  }

  renderCards() {
    const { lastSearchCookies, source, maxOptionals, title } = this.props;
    
	if (!Array.isArray(source) || !source.length) {
		return false;
	  }

    const newLinks = this.generateUrls(lastSearchCookies);
    const renderArr = source.slice(0, 5).map((item, i) => {
      item.filters = item.route.split('/').slice(1).join('/');
      const filters = parseSearchFilters(
        item.filters,
        decodeURIComponent(removeQueryParameter(removeQueryParameter(item.query, 'idrevendedor'), 'o'))
      ) || {};

      const [make, model, smallText] = this.renderMakeModel(filters);
      const lkidValue = LastSearches.LKID + i;
      const updatedLink = this.addOrUpdateLkid(newLinks[i], lkidValue);

      return (
        <CardUltimasBuscas
          key={`homeSearches${lkidValue}`}
          make={make}
          model={model}
          source={filters || 0}
          id={item.id || ''}
          maxOptionals={maxOptionals || false}
          linkTo={updatedLink}
          smallText={smallText}
          title={title || ''}
		      data-testid="card"
        />
      );
    });

    return renderArr.length ? renderArr : <span />;
  }
  generateUrls(dataArray) {
    return Array.isArray(dataArray) 
      ? dataArray.map(item => `${item.route}${item.query}`)
      : [];
  }
  addOrUpdateLkid(url, lkidValue) {
    if (url && url.includes('lkid=')) {
      return url.replace(/lkid=\d+/g, `lkid=${lkidValue}`);
    } else {
      return `${url}&lkid=${lkidValue}`;
    }
  }
  renderTitle() {
    return this.props.title && <h3 className="container">{this.props.title}</h3>;
  }

  render() {
    const { source, className, id } = this.props;

    return (
      <Fragment>
        {source && source.length && (
          <div className='LastSearch__Box-title'>
            {this.renderTitle()}
          </div>
        )}
        <div className={`LastSearch__Box ${className || ''}`} id={id || ''}>
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
